module.exports = __webpack_public_path__ + "static/novartis_ani-a1dd02de9e83d9f30f6d57b651cc8ad5.webm";